
import axios from '@/axios.js'

const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(.\d+)?Z$/;
const formatDates = (obj) => {
  if (obj === null || obj === undefined) return obj;
  if (typeof obj === 'object') {
      if (obj instanceof Date) {
          return obj.toLocaleString();
      }
      if (obj.$date) {
          return new Date(obj.$date).toLocaleString();
      }
      for (const key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
              obj[key] = formatDates(obj[key]);
          }
      }
      return obj;
  }
  if (typeof obj === 'string' && isoDateRegex.test(obj)) {
      return new Date(obj).toLocaleString();
  }
  return obj;
}

export default {
  namespaced: true,
  state: {
    data:[],
    dataLog: []
  },
  getters: {
    getData:state=>{
      return state.data;
    },
    getDataLog:state=>{
      return state.dataLog;
    }
  },
  mutations: {
    SAVE_DATA(state,payload){
      state.data = payload
    },
    SAVE_DATA_LOG(state,payload){
      state.dataLog = payload
    }
  },
  actions: {
    getItems({ commit }, payload){
      return new Promise((resolve, reject) => {
        commit('SAVE_DATA', [])
        axios
        .get(`/manufacture/master-data/admin/item-list?type=${payload.type}&search=${payload.search}&dateSearch=${payload.dateSearch}&page=${payload.page}&entry=${payload.entry}`)
        .then(res => {
          commit('SAVE_DATA', res.data.data)
          resolve(res.data.metadata)
        })
        .catch(err => {
          alert(err);
          reject(err)
        })
      })
    },
    updateItem({ commit }, {payload, id, type}) {
      return new Promise((resolve, reject) => {
        axios.put(`/manufacture/master-data/admin/update-item/${id}?type=${type}`, payload)
        .then(res => {
          commit('SAVE_DATA', res.data.data)
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        });
      })
    },
    getAdminLogById({ commit }, {id}) {
      return new Promise((resolve, reject) => {
        axios.get(`/manufacture/master-data/admin/admin-log/${id}`)
        .then(res => {
          let result = formatDates(res.data.data)
          result.before = Object.keys(result.before).sort().reduce((obj, key) => {
            obj[key] = result.before[key];
            return obj;
          }, {});
          result.after = Object.keys(result.after).sort().reduce((obj, key) => {
            obj[key] = result.after[key];
            return obj;
          }, {});
          
          // commit('SAVE_DATA', res.data.data)
          console.log("🚀 ~ getAdminLogById ~ result:", result)

          
          resolve(result)
        })
        .catch(err => {
          reject(err)
        });
      })
    },
    getAdminLog({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios.get(`/manufacture/master-data/admin/admin-log?search=${params.search}&page=${params.page}&entry=${params.entry}`)
        .then(res => {
          commit('SAVE_DATA_LOG', res.data.data)
          resolve(res.data.metadata)
        })
        .catch(err => {
          reject(err)
        });
      })
    }
  }
}
